import React, { useState } from 'react'
import './Navbar.css'

const Navbar = () => {
  const [active,setActive] = useState(false);

  window.addEventListener('scroll', () => {
    if(window.scrollY > 0){
      setActive(true);
    }else{
      setActive(false);
    }
  })

  return (
    <div className={`navbar ${active && 'sticky'}`}>
        <a href="#home" className='navlink'>Home</a>
        <a href="#portfolio" className='navlink'>Portfolio</a>
        <a href="#resume" className='navlink'>Resume</a>
        <a href="#about" className='navlink'>About</a>
        <a href="#contact" className='navlink'>Contact</a>
    </div>
  )
}

export default Navbar